const AIChatDBName = 'AIChatDBNameCacheAudio';
const AIChatDBStoreName = 'AIChatDBStoreName';
let db: IDBDatabase | null = null;

export const AIAudioCacheService = () => {
    const generateId = (botId?: string, messageId?: string) => {
        if (!botId || !messageId) return;
        return `${botId}-${messageId}`;
    };
    const checkAudioAlreadyCached = (id?: string): Promise<boolean> => {
        if (!id) {
            return Promise.resolve(false);
        }
        return new Promise((resolve, reject) => {
            if (!db) {
                reject(new Error('db open failed'));
                return;
            }
            const transaction = db.transaction([AIChatDBStoreName], 'readonly');
            const store = transaction.objectStore(AIChatDBStoreName);
            const request = store.get(id);
            request.onsuccess = event => {
                const { result } = event.target as IDBRequest;
                console.log('social-ai', 'check Audio Already Cached', event.target, id);
                if (result) {
                    resolve(true);
                } else {
                    resolve(false);
                }
            };

            request.onerror = event => {
                const error = (event?.target as IDBOpenDBRequest)?.error;
                reject(error);
            };
        });
    };

    const openAudioDatabase = (): Promise<IDBDatabase> => {
        return new Promise((resolve, reject) => {
            const request = indexedDB.open(AIChatDBName, 1);
            request.onupgradeneeded = (event: IDBVersionChangeEvent) => {
                db = (event?.target as IDBOpenDBRequest)?.result;
                const objectStore = db.createObjectStore(AIChatDBStoreName, { keyPath: 'id' });
                objectStore.createIndex('url', 'url', { unique: false });
                console.log('social-ai', 'create audio db sucessfully');
            };

            request.onsuccess = event => {
                const dataBase = (event?.target as IDBOpenDBRequest)?.result;
                db = dataBase;
                console.log('social-ai', 'open audio db sucessfully', dataBase);
                resolve(db);
            };
            request.onerror = event => {
                const error = (event?.target as IDBOpenDBRequest)?.error;
                console.log('social-ai', 'open audio db failed', error);
                reject(db);
            };

            console.log('social-ai', 'openAudioDatabase');
        });
    };

    // id :${botId)-${conversationId}-${messageId}
    const cacheAudioFile = async (url?: string, id?: string): Promise<string | undefined> => {
        if (!url || !id) {
            return Promise.resolve('url or id cannot be null or undefined');
        }
        const db = await openAudioDatabase();
        if (await checkAudioAlreadyCached(id)) {
            console.log('social-ai', 'audio already cached');
            return Promise.resolve('audio already cached');
        }

        console.log('social-ai', 'audio not cached');
        const response = await fetch(url);
        if (!response.ok) {
            return Promise.resolve('fetch audio failed');
        }

        const blob = await response.blob();
        if (!blob) {
            return Promise.resolve('blob wrong');
        }
        return new Promise((resolve, reject) => {
            try {
                const transaction = db!.transaction([AIChatDBStoreName], 'readwrite');
                const store = transaction.objectStore(AIChatDBStoreName);
                const audioFile = { id, url, blob };
                console.log('social-ai', 'try to cache:', audioFile);
                const request = store.put(audioFile);
                request.onsuccess = event => {
                    console.log('social-ai', 'audio file is cached:', id);
                    const countRequest = store.count();
                    countRequest.onsuccess = event => {
                        const currentCount = (event.target as IDBRequest<number>).result;
                        let deleteCount = 10;
                        if (currentCount > 20) {
                            const earliestRequest = store.openCursor();
                            earliestRequest.onsuccess = event => {
                                const cursor = (event.target as IDBRequest<IDBCursor>).result;
                                if (cursor) {
                                    const deleteRequest = cursor.delete();
                                    deleteRequest.onsuccess = event => {
                                        if (deleteCount <= 0) {
                                            return;
                                        }
                                        cursor.continue();
                                        deleteCount -= 1;
                                    };

                                    deleteRequest.onerror = event => {
                                        if (deleteCount <= 0) {
                                            return;
                                        }
                                        cursor.continue();
                                        deleteCount -= 1;
                                    };
                                    console.log('social-ai', 'deleted earliest audio file');
                                }
                            };
                        }
                    };

                    countRequest.onerror = event => {
                        console.log('social-ai', 'count error:', (event?.target as IDBOpenDBRequest)?.error);
                    };
                    resolve('audio file is cached');
                };

                request.onerror = event => {
                    console.log('social-ai', 'audio file wrongly cached:', id, (event?.target as IDBOpenDBRequest)?.error);
                    resolve('audio file wrongly cached');
                };
            } catch (error) {
                console.log('social-ai', 'cache error:', error);
                reject();
            }
        });
    };

    const getAudioFileFromCache = (id?: string): Promise<Blob | null | string> => {
        if (!id) {
            return Promise.resolve('url or id cannot be null or undefined');
        }
        return new Promise((resolve, reject) => {
            if (!db) {
                reject(new Error('db open failed'));
                return;
            }
            const transaction = db.transaction([AIChatDBStoreName], 'readonly');
            const store = transaction.objectStore(AIChatDBStoreName);
            const request = store.get(id);
            request.onsuccess = event => {
                const { result } = event.target as IDBRequest;
                console.log('social-ai', 'store get by id', event.target);
                if (result) {
                    resolve(result.blob);
                } else {
                    resolve(null);
                }
            };

            request.onerror = event => {
                const error = (event?.target as IDBOpenDBRequest)?.error;
                reject(error);
            };
        });
    };

    return { generateId, cacheAudioFile, getAudioFileFromCache, checkAudioAlreadyCached };
};

export default AIAudioCacheService;
